import { BuilderAreaExisting } from './BuilderArea/BuilderArea'
import NodeViewer from './NodeViewer/NodeViewer'

export default function ViewLayout({ id }: { id: string }) {
  return (
    <section id="builder-content" className="main-content">
      <BuilderAreaExisting id={id} readOnly />
      <NodeViewer readOnly />
    </section>
  )
}
